import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useSound from "use-sound";
import { initiateCountDown } from "../../redux/reducers/videoReducer";
import DBLPOP from "../../assets/music/DBLPOP.mp3";
import ButtonBack from "../../assets/images/others/ButtonBack3.png";
import ButtonNext from "../../assets/images/others/ButtonNext3.png";
import s from "./style.module.css";

const ButtonController = ({
  contentID,
  videoLink,
  disableBack,
  disableNext,
  onPressBack,
  onPressNext,
}) => {
  const [play] = useSound(DBLPOP);
  const [renderBtn, setRenderBtn] = useState(false);
  const countDown = useSelector((state) => state.countDown);
  const dispatch = useDispatch();
  const renderButton = () => {
    setTimeout(() => {
      setRenderBtn(true);
    }, 10000);
  };
  useEffect(() => {
    setRenderBtn(false);
    if (videoLink) {
      if (countDown) {
        renderButton();
      }
    } else {
      setRenderBtn(true);
    }
  }, [contentID, videoLink, countDown]);

  return (
    <React.Fragment>
      <div className={s.buttonWrapper}>
        <div>
          {disableBack !== 1 && (
            <img
              style={{ filter: "grayScale(40%)" }}
              onClick={() => {
                onPressBack();
                play();
              }}
              src={ButtonBack}
              alt="ButtonBack"
            />
          )}
        </div>
        <div>
          {disableNext !== 1 && renderBtn && (
            <img
              onClick={() => {
                onPressNext();
                dispatch(initiateCountDown(false));
                play();
              }}
              src={ButtonNext}
              alt="ButtonNext"
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ButtonController;
